import React, { useEffect, useState } from 'react'
// import Bannersection from './Bannersection'
import AboutSection from './AboutSection'
import ServiceSection from './ServiceSection'
import CourseSection from './CourseSection'
import FindSection from './FindSection'
import Process from './Process'
import HighLights from './HighLights'
import Testimonials from './Testimonials'
import Blogs from '../../Reusable/Blogs'
import HeroSection from './HeroSection'
import TrustBar from './TrustBar'

// import { blog_data } from '../Blogs/blog_data'
import { axiosInstance } from '../config'
import CTASection from '../../common/CTASection'


const Index = () => {

    const [blogs,setblogs] = useState([])
 
    useEffect(() => {
        getBlogs();
    },[])

    function getBlogs() { 

        axiosInstance.get(`get-posts`)
            .then(res => {
                // console.log(res.data)
                setblogs(res.data.posts.reverse())
            })
            .catch((err) => console.log(err))
             
    }

    return (
        <div> 
            {/* <Bannersection /> */}
            <HeroSection />
            <TrustBar />
            <CTASection/>
            <AboutSection />
            <ServiceSection />
            <CourseSection />
            <FindSection />
            <div className='padding-div'>
                <Process />
            </div>
            <HighLights />
            <Testimonials />
            <Blogs blogs={blogs.slice(0,3)} heading='Latest from our blog post' />
        </div>
    )
}

export default Index
